import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";

export class CourseTaskQuestion{
    constructor(
      public id:string,
      public name:string = "",
      public description:string = "",
      public type: 'open'|'multiple-answer'|'multiple-choice' = "open",
      public required: boolean,
      public options: {
        id: string,
        name: string,
        selected:boolean,
        score:number
      }[] = [],
      public openAnswer:string = "",
      public score:number = 0,
      public image:string = "",
      public article:string =""
    ){}

}


@Injectable({
  providedIn: 'root'
})
export class CourseTaskQuestionAdapter implements Adapter<CourseTaskQuestion> {
  constructor(){}
  adapt(item: any): CourseTaskQuestion {
    let q =  new CourseTaskQuestion(
      item.id,
      item.name,
      item.description,
      item.type,
      item.required,
      item.options
    );

    q.image = item.image ? item.image.fileObject.fileUrl ?? '' : '';
    q.article = item.article??'';

    return q;
  }
}
